import React from 'react';
import { Router, Route, Switch, Redirect } from 'react-router-dom';
import { history } from './_helpers';
import { PrivateRoute } from './_components';
import { NAV_LINKS } from './_constants';
import { LoginPage, UserManagementPage, IEManagementPage, PlantManagementPage, StudyBrowserPage, ReportsPage, PreStudyPage } from "./pages";
import BiReportsPage from './pages/ReportsPage/BiReport/BiReportsPage';

function App() {

	return (
		<Router history={history}>
			<Switch>
				<PrivateRoute exact isOnlyAdmin={true} path={NAV_LINKS.USER_MGT} component={UserManagementPage} />
				<PrivateRoute exact isOnlyAdmin={false} path={NAV_LINKS.IE_MGT} component={IEManagementPage} />
				<PrivateRoute exact isOnlyAdmin={true} path={NAV_LINKS.PLANT_MGT} component={PlantManagementPage} />
				<PrivateRoute exact isOnlyAdmin={false} path={NAV_LINKS.STUDY_BROWSER} component={StudyBrowserPage} />
				<PrivateRoute exact isOnlyAdmin={false} path={NAV_LINKS.REPORTS} component={ReportsPage.YamazumiReportsPage} />
				<PrivateRoute exact isOnlyAdmin={false} path={NAV_LINKS.BI_REPORTS} component={ReportsPage.BiReportsPage} />
				<PrivateRoute exact isOnlyAdmin={false} path={NAV_LINKS.PRE_STUDY_SEARCH} component={PreStudyPage} />
				<PrivateRoute exact isOnlyAdmin={false} path={NAV_LINKS.PRE_STUDY_CREATE} component={PreStudyPage} />
				<PrivateRoute exact isOnlyAdmin={false} path={NAV_LINKS.PRE_STUDY_SEARCH_ID} component={PreStudyPage} />
				<Route path={NAV_LINKS.LOGIN} component={LoginPage} />
				<Redirect from="*" to={NAV_LINKS.USER_MGT} />
			</Switch>
		</Router>
	);
}

export { App };
